import { Component, inject } from '@angular/core';
import { FenceService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  FenceCreateDto,
  FenceDto,
  FenceExcelDownloadDto,
  FenceUpdateDto,
} from '../proxy/planning/dtos/fence';
import { FENCE_CONFIG, FENCE_FIELDS } from './fence.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-fence',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, FenceService, ConfirmationService],
  templateUrl: './fence.html',
  styleUrl: './fence.scss',
})
export class Fence extends BaseHierarchicalCrudComponent<
  FenceDto,
  FenceCreateDto,
  FenceUpdateDto,
  FenceExcelDownloadDto
> {
  service = inject(FenceService);
  config = FENCE_CONFIG;
  fields = FENCE_FIELDS;

  protected prepareUpdateDto(data: any, selected: FenceDto): FenceUpdateDto {
    return {
      name: data.name,
      gisFenceId: data.gisFenceId,
      locationId: data.locationId,
      propertyId: data.propertyId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Fence';
  }
}
